// ----------------------------------------------------------------------------
// Nombre del Programa : index
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se carga al iniciar la pagina, esta carga los valores que contiene el documento de configuraciones como el apiurl,apigoogle etc, esta clase valida cual sera  la primera vista a mostrarse
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import React from 'react';
import ReactDOMClient from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './global.scss';
import { Main } from './views/main/Main';
import store from './store';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga4';
import env from './env.json';
import axios from 'axios';
import { setApiUrl, setApiCliGoo, setApiKe, setMaxArcMB, setMaxImgMB, setadm } from './Utilidades/session';
import { PaginaError } from './views/pagina-error/PaginaError';


//se realizo cambio pedido por prosa para que cargue las configuraciones desde
//un txt, se valido que cargue el txt una sola vez por caga de pagina y se guardan en variables de sesion
//se carga el contenido de la pagina hasta que carga el txt
let pathtxt = window.location.origin + env.CONFIG_PATH;

console.log('PATH---------------',pathtxt);

axios.get(pathtxt, {
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }
}).then(function (response) {
  let responsed = response.data;
  let lines = responsed.split("\n");
  var apcligoo = "";
  var appk = "";
  var appur = "";
  var gooanalit = "";
  var maxarmb = "";
  var maximmb = "";

  lines.forEach((contenido) => {
    if (contenido.includes("API_CLIENTID_GOOGLE")) {
      apcligoo = contenido.replace("API_CLIENTID_GOOGLE=", "").replace("\r", "");
    }
    else if (contenido.includes("APIKEY")) {
      appk = contenido.replace("APIKEY=", "").replace("\r", "");
    }
    else if (contenido.includes("API_URL")) {
      appur = contenido.replace("API_URL=", "").replace("\r", "");
    }
    else if (contenido.includes("GOOGLE_ANALYTICS_KEY")) {
      gooanalit = contenido.replace("GOOGLE_ANALYTICS_KEY=", "").replace("\r", "");
    }
    else if (contenido.includes("MAX_ARCHIVE_MB")) {
      maxarmb = contenido.replace("MAX_ARCHIVE_MB=", "").replace("\r", "");
    }
    else if (contenido.includes("MAX_IMAGE_MB")) {
      maximmb = contenido.replace("MAX_IMAGE_MB=", "").replace("\r", "");
    }
  });


  setApiUrl(appur)
  setApiCliGoo(apcligoo)
  setApiKe(appk)
  setMaxArcMB(maxarmb)
  setMaxImgMB(maximmb)
  //Modificacion: Marca de Inicio WII C-24-1229-24
  setadm("0")
  //Modificacion: Marca de Fin WII C-24-1229-24

  ReactGA.initialize(gooanalit);

  const root = ReactDOMClient.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <Main></Main>
      </React.StrictMode>
    </Provider>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();

})
  .catch(function (error) {
    const root = ReactDOMClient.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(
      <Provider store={store}>
        <React.StrictMode>
          <PaginaError></PaginaError>
        </React.StrictMode>
      </Provider>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
  });
